module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "2",
      "height": "12",
      "viewBox": "0 0 2 12",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0.125 1.60938C0.125 1.84144 0.217187 2.064 0.381281 2.22809C0.545376 2.39219 0.767936 2.48438 1 2.48438C1.23206 2.48438 1.45462 2.39219 1.61872 2.22809C1.78281 2.064 1.875 1.84144 1.875 1.60938C1.875 1.37731 1.78281 1.15475 1.61872 0.990657C1.45462 0.826562 1.23206 0.734375 1 0.734375C0.767936 0.734375 0.545376 0.826562 0.381281 0.990657C0.217187 1.15475 0.125 1.37731 0.125 1.60938ZM0.125 5.98438C0.125 6.21644 0.217187 6.439 0.381281 6.60309C0.545376 6.76719 0.767936 6.85938 1 6.85938C1.23206 6.85938 1.45462 6.76719 1.61872 6.60309C1.78281 6.439 1.875 6.21644 1.875 5.98438C1.875 5.75231 1.78281 5.52975 1.61872 5.36566C1.45462 5.20156 1.23206 5.10938 1 5.10938C0.767936 5.10938 0.545376 5.20156 0.381281 5.36566C0.217187 5.52975 0.125 5.75231 0.125 5.98438ZM0.125 10.3594C0.125 10.5914 0.217187 10.814 0.381281 10.9781C0.545376 11.1422 0.767936 11.2344 1 11.2344C1.23206 11.2344 1.45462 11.1422 1.61872 10.9781C1.78281 10.814 1.875 10.5914 1.875 10.3594C1.875 10.1273 1.78281 9.90475 1.61872 9.74066C1.45462 9.57656 1.23206 9.48438 1 9.48438C0.767936 9.48438 0.545376 9.57656 0.381281 9.74066C0.217187 9.90475 0.125 10.1273 0.125 10.3594Z",
      "fill": "#004A98"
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4dd055b9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4dd055b9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/More.vue
// module id = 1495
// module chunks = 159